import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import Facebook from "../../assets/icons/facebook.svg";
import Instagram from "../../assets/icons/instagram.svg";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ObfuscatedLink from "../obfuscated-link";

const Footer = () => {
  const data = useStaticQuery(query);
  return (
    <footer >
      <div className="container">
        {/* Les titres de colonne ne sont ni des liens ni des balises de titre : ils présentent seulement la liste (comme sur le site FR). */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-x-4 text-sm">

          <div>
            <div className="w-32 mb-4">
              <GatsbyImage
                image={getImage(data.image1)}
                className="w-full"
                alt="Logo del Taller del Tote Bag"
              />
            </div>
            <div className="font-semibold text-base text-white uppercase mb-2">Quiénes somos</div>
            <ul className="mb-6">
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/las-creaciones-del-taller-del-tote-bag">Nuestras creaciones</Link></li>
              <li><Link to="/contacto-el-taller-del-tote-bag">Contacto</Link></li>
              <li><ObfuscatedLink className="text-white" to="/preguntas-sobre-fabrication-tote-bags-personalizados">Dudas frecuentes</ObfuscatedLink></li>
              <li><Link to="/condiciones-generales-de-venta">Condiciones generales</Link></li>
              <li><Link to="/menciones-legales">Aviso legal</Link></li>
              <li><Link to="/politica-de-cookies">Política privacidad</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-semibold text-base text-white uppercase mb-2">Productos</div>
            <ul className="mb-6">
              <li><Link to="/fabricacion-a-medida">Fabricación a medida</Link></li>
              <li><Link to="/categoria-producto/bolsas-personalizadas">Totebags personalizadas</Link></li>
              <li><Link to="/categoria-producto/bolsas-algodon-ecologico">Totebags ecológicas personalizadas</Link></li>
              <li><Link to="/categoria-producto/bolsas-compra">Bolsos de tela personalizadas</Link></li>
              <li><Link to="/categoria-producto/bolsos-yute">Bolsas de yute</Link></li>
              <li><Link to="/categoria-producto/sacos-tela-personalizados">Sacos de tela personalizados</Link></li>
              <li><Link to="/categoria-producto/neceser-personalizado">Neceser personalizado</Link></li>
              <li><Link to="/categoria-producto/mochilas-cuerdas">Mochilas de cuerdas personalizadas</Link></li>
              <li><ObfuscatedLink className="text-white" to="/categoria-producto/camisetas-personalizadas-hombre">Camisetas personalizadas para hombre</ObfuscatedLink></li>
              <li><ObfuscatedLink className="text-white" to="/categoria-producto/camisetas-personalizadas-mujer">Camisetas personalizadas para mujer</ObfuscatedLink></li>
              <li><ObfuscatedLink className="text-white" to="/categoria-producto/camisetas-personalizadas-ninos">Camisetas personalizadas para niños</ObfuscatedLink></li>
              <li><ObfuscatedLink className="text-white" to="/categoria-producto/gorras-personalizadas">Gorras personalizadas</ObfuscatedLink></li>
            </ul>
          </div>

          <div>
            <div className="font-semibold text-base text-white uppercase mb-2">Técnicas</div>
            <ul className="mb-6">
              <li><Link to="/impresion-serigrafia">Serigrafía</Link></li>
              <li><Link to="/impresion-digitale">Impresión digital</Link></li>
              <li><Link to="/impresion-transferencia">Impresión por transferencia</Link></li>
              <li><Link to="/impresion-bordado">Bordado</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-semibold text-base text-white uppercase mb-2">Nuestras totebags personalizadas</div>
            <ul className="mb-6">
              <li><Link to="/mayorista-tote-bag">Mayorista tote bag</Link></li>
              <li><Link to="/categoria-producto/bolsas-bodas">Bolsas de tela personalizadas para bodas</Link></li>
              <li><Link to="/tote-bag-para-empresas">Bolsas personalizadas para empresas</Link></li>
              <li><Link to="/categoria-producto/bolsas-algodon">Bolsas de algodón</Link></li>
              <li><Link to="/categoria-producto/fabricacion-europea">Bolsas de fabricación europea</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-semibold text-base text-white uppercase mb-2">Contacto</div>
            <ul className="mb-6">
              <li className="flex space-x-6">
                <a
                  className="block border-2 border-blue-light rounded-full p-2 hover:bg-blue-light"
                  href="https://www.facebook.com/tallerdeltotebag"
                  target="_blank"
                  rel="nofollow, noreferrer"
                >
                  <Facebook width="20" className="text-white fill-current" />
                </a>
                <a
                  className="block border-2 border-blue-light rounded-full p-2 hover:bg-blue-light"
                  href="https://www.instagram.com/latelierdutotebag"
                  target="_blank"
                  rel="nofollow, noreferrer"
                >
                  <Instagram width="20" className="text-white fill-current" />
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
      <div className="text-xs text-gray-200 text-center mt-4">
        © Copyright {new Date().getFullYear()}, El Taller del Tote Bag
      </div>
    </footer >
  );
};

const query = graphql`
  query {
    image1: file(
      relativePath: { eq: "LOGO-ATELIER-ESPAGNOLE-blanc.png.webp" }
      sourceInstanceName: { eq: "uploads" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 150, quality: 100) 
      }
    }
  }
`;

export default Footer;
